import { Button } from './Button';
import { Buttons as ButtonsComponent, ButtonsMultiple } from './Buttons';

export { ToggleButtonSize } from '../types';
export { Button, Buttons, ButtonsMultiple };

// eslint-disable-next-line functional/immutable-data -- Assign sub buttons components
const Buttons = Object.assign(ButtonsComponent, { Button, Multiple: ButtonsMultiple });
